const dateTime = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });

/** "22/10/2026 11:30", no fuso do aparelho. Data inválida devolve o texto original (nunca "Invalid Date"). */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : dateTime.format(date).replace(',', '');
}
